'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindActions = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _handlers = require('./handlers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bindActions = exports.bindActions = function bindActions() {
  $(_Dom2.default.overlay).on('click', _handlers.hideOverlay);
};